$(document).on('turbolinks:load', function () {
  var activeDropdown = void 0;
  const dropdownElements = $('*[dropdown]');

  function closeAllDropdownElements() {
    dropdownElements.each((index, dropdown) => {
      if ($(dropdown).hasClass('dropdown-open')) {
        $(dropdown).removeClass('dropdown-open');
      }
    });
  }

  dropdownElements.each((index, dropdown) => {
    const dropdownContent = $(dropdown).children().last();

    $(dropdownContent).addClass('dropdown-select-content');

    $(dropdown).on('click', function (e) {
      if ($(e.target).closest('.dropdown-select-content').length === 1) return true;
      if (window.innerWidth < 810) return true;

      const dropdownTrigger = $(e.target).closest('*[dropdown]');
      const isDropdownOpen = $(dropdownTrigger).hasClass('dropdown-open');

      if (!isDropdownOpen) {
        activeDropdown = dropdown;
        closeAllDropdownElements();
        $(document).trigger('onDropdownOpened', { element: dropdown });
      } else {
        setTimeout(() => {
          closeAllDropdownElements();
        }, 30);

        return false;
      }

      const props = {};
      let attr = $(dropdown).attr('dropdown');
      attr = attr ? attr.split(',') : [];

      for (let i = 0; i < attr.length; i++) {
        if (!attr[i].split(':')[0]) break;
        props[attr[i].split(':')[0].trim()] = attr[i].split(':')[1].trim();
      }

      if (props.position && (props.position === 'left' || props.position === 'right')) {
        const cssObj = {};
        cssObj[props.position] = 0;
        $(dropdownContent).css(cssObj);
      } else {
        $(dropdownContent).css({ left: 0 });
      }

      if (props.type === 'order') {
        $(dropdownContent)
          .children()
          .each((index, listItem) => {
            $(listItem).on('click', function () {
              setActiveOrderDropdown(dropdownContent, index);
              const dropdownLabel = $(dropdown).children('.dropdown-select-label')[0];
              $(dropdownLabel).html($(this).html());
              $(document).trigger('onFilterOrderChanged', { value: $(this).data('value') });
            });
          });
      }

      $(dropdown).addClass('dropdown-open');
    });
  });

  $(document).on('click', function (e) {
    if (window.innerWidth < 810) return true;
    
    if (!$(activeDropdown).is(e.target) && $(activeDropdown).has(e.target).length === 0) {
      closeAllDropdownElements();
    }
  });

  $(document).on('keyup', function(e) {
    if (e.key === "Escape") {
      closeAllDropdownElements();
    }
  });

  function setActiveOrderDropdown(dropdownContent, index) {
    $(dropdownContent)
      .children()
      .each((i, e) => {
        $(e).removeClass('active');
        if (index === i) {
          $(e).addClass('active');
        }
      });
  }
});
